import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DevExtremeModule } from '../devextreme.module';
import { EtsSymbolPickerModule } from '../symbol-picker/symbol-picker.module';
import { PriceChartComponent } from './price-chart.component';
import { PriceChartPanelComponent } from './price-chart-panel.component';

@NgModule({
   imports: [
      CommonModule,
      DevExtremeModule,
      EtsSymbolPickerModule
   ],
   declarations: [
      PriceChartComponent,
      PriceChartPanelComponent
   ],
   exports: [
      PriceChartPanelComponent
   ]
})
export class EtsPriceChartModule { }
